'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _PubNubMessageRecord = require('../pubnub-message/records/PubNubMessageRecord');

var _PubNubMessageRecord2 = _interopRequireDefault(_PubNubMessageRecord);

var _ThreadPreviewRecord = require('../thread-preview/records/ThreadPreviewRecord');

var _ThreadPreviewRecord2 = _interopRequireDefault(_ThreadPreviewRecord);

var _LatestEmailMessage = require('./LatestEmailMessage');

var _LatestEmailMessage2 = _interopRequireDefault(_LatestEmailMessage);

var _Visitor = require('./Visitor');

var _Visitor2 = _interopRequireDefault(_Visitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _immutable.Record)({
  agentChannel: null,
  assignedAgentId: null,
  assignedAgentType: null,
  channel: null,
  emailAccountId: null,
  endedAt: null,
  filtered: null,
  filteredSource: null,
  inboxId: null,
  latestEmailMessage: (0, _LatestEmailMessage2.default)(),
  latestMessage: (0, _PubNubMessageRecord2.default)(),
  latestMessageSeen: false,
  latestReadTimestamp: 0,
  latestSessionEndedAt: null,
  latestSessionStartedAt: null,
  messageId: null,
  messageName: null,
  messagesUtk: null,
  portalId: null,
  responder: null,
  source: null,
  startedAt: null,
  status: null,
  threadPreview: (0, _ThreadPreviewRecord2.default)(),
  threadStatus: null,
  threadId: null,
  unseenCount: 0,
  url: null,
  userId: null,
  vid: null,
  visitor: (0, _Visitor2.default)()
}, 'Conversation');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/Conversation.js
// module id = 41
// module chunks = 2 3